import http from '../../utils/services/http';
import { GetLabelsRequestParams } from '../../../common/api/labels/labelRouteTypes';
import { BoardVirtualPathMap, LabeledElementsData } from '../../../common/api/labels/labelElementsRetrievalRouteTypes';

export const fetchLabelsFromDb = async (params: GetLabelsRequestParams = {}) => {
    const response = await http({
        method: 'get',
        url: `labels`,
        params,
    });

    return response.data.labels;
};

export const getLabelUsageData = async (
    labelId: string,
    userRootBoard: string,
): Promise<{
    labeledElements: LabeledElementsData[];
    boardVirtualPathToRootMap: BoardVirtualPathMap;
}> => {
    const response = await http({
        method: 'get',
        url: `labels/${labelId}/usage`,
        params: { userRootBoard },
    });

    return response.data;
};
